import { render, staticRenderFns } from "./KpiLayout.vue?vue&type=template&id=61f01a8d&scoped=true&"
import script from "./KpiLayout.vue?vue&type=script&lang=js&"
export * from "./KpiLayout.vue?vue&type=script&lang=js&"
import style0 from "./KpiLayout.vue?vue&type=style&index=0&id=61f01a8d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f01a8d",
  null
  
)

export default component.exports